/** Alapértelmezés — szinkronban a backend/site_content.py-val. */
export const DEFAULT_SITE_CONTENT = {
  "brand": {
    "name": "Auto",
    "name_highlight": "Park",
    "organization_name": "AutoPark"
  },
  "seo": {
    "default_title": "AutoPark – Prémium használtautó marketplace",
    "default_description": "AutoPark: prémium használtautók Magyarországon. 360° megtekintés, részletes felszereltség, kedvencek és azonnali üzenetküldés az eladónak.",
    "title_suffix": "AutoPark"
  },
  "global_banner": {
    "enabled": false,
    "text": "",
    "href": ""
  },
  "nav": {
    "links": [
      {
        "label": "Főoldal",
        "path": "/#hero",
        "kind": "hash",
        "visible": true
      },
      {
        "label": "Készlet",
        "path": "/#keszlet",
        "kind": "hash",
        "visible": true
      },
      {
        "label": "AI Tanácsadó",
        "path": "/#ai",
        "kind": "hash",
        "visible": true
      },
      {
        "label": "Kreditek",
        "path": "/kreditek",
        "kind": "route",
        "visible": true
      },
      {
        "label": "Szolgáltatások",
        "path": "/szolgaltatasok",
        "kind": "route",
        "visible": true
      }
    ]
  },
  "footer": {
    "copyright": "Minden jog fenntartva.",
    "links": [
      {
        "label": "Készlet",
        "path": "/#keszlet",
        "kind": "hash",
        "visible": true
      },
      {
        "label": "Szolgáltatások",
        "path": "/szolgaltatasok",
        "kind": "route",
        "visible": true
      },
      {
        "label": "ÁSZF",
        "path": "/aszf",
        "kind": "route",
        "visible": true
      },
      {
        "label": "Adatvédelem",
        "path": "/adatvedelem",
        "kind": "route",
        "visible": true
      },
      {
        "label": "AI Tanácsadó",
        "path": "/#ai",
        "kind": "hash",
        "visible": true
      },
      {
        "label": "Admin",
        "path": "/admin",
        "kind": "route",
        "visible": true
      }
    ],
    "show_brand_marquee": true
  },
  "home_sections": [
    {
      "id": "featured_reviews",
      "enabled": true
    },
    {
      "id": "inventory",
      "enabled": true
    },
    {
      "id": "ai_recommender",
      "enabled": true
    },
    {
      "id": "site_reviews",
      "enabled": true
    },
    {
      "id": "contact",
      "enabled": true
    }
  ],
  "hero": {
    "video_mp4": "/hero/hero-car.mp4",
    "video_mp4_light": "/hero/hero-car-light.mp4",
    "video_mov": "/hero/hero-car.mov",
    "badge": "Prémium minőség, valós érték",
    "title_before": "Minőségi, ellenőrzött használt autók egyenesen a ",
    "title_highlight": "kereskedőktől",
    "title_after": ".",
    "subtitle": "Gondosan válogatott, megbízható autók az AutoPark kínálatában. Fedezd fel készletünket, hasonlítsd össze a modelleket, és találd meg a tökéletes választást.",
    "cta_primary_label": "Készlet megtekintése",
    "cta_primary_href": "#keszlet",
    "cta_secondary_label": "AI Tanácsadó",
    "cta_secondary_href": "#ai",
    "stats": [
      {
        "id": "count",
        "value_override": "",
        "label": "Elérhető autó",
        "dynamic": "inventory_count"
      },
      {
        "id": "verified",
        "value": "100%",
        "label": "Ellenőrzött állapot",
        "dynamic": ""
      },
      {
        "id": "price_range",
        "value_override": "",
        "label": "Ft árkategória",
        "dynamic": "price_range"
      }
    ]
  },
  "featured_reviews": {
    "eyebrow": "Vevői visszajelzés",
    "aggregate_suffix": "értékelés alapján · Összes megtekintése →",
    "auto_rotate_ms": 6000
  },
  "inventory": {
    "eyebrow": "Készlet",
    "title": "Fedezd fel a kínálatunkat",
    "description": "Szűrj márka, üzemanyag, évjárat és ár szerint, majd rendezd az igényeid alapján.",
    "filter_labels": {
      "make": "Márka",
      "fuel": "Üzemanyag",
      "year": "Évjárat",
      "sort": "Rendezés",
      "area": "Terület",
      "price": "Árkategória"
    },
    "sort_options": [
      {
        "id": "recommended",
        "label": "Ajánlott (kiemeltek elöl)"
      },
      {
        "id": "price-asc",
        "label": "Ár szerint (növekvő)"
      },
      {
        "id": "price-desc",
        "label": "Ár szerint (csökkenő)"
      },
      {
        "id": "year-desc",
        "label": "Évjárat (legújabb)"
      },
      {
        "id": "power-desc",
        "label": "Teljesítmény (legtöbb)"
      }
    ],
    "make_all_label": "Összes márka",
    "fuel_all_label": "Összes",
    "year_all_label": "Bármelyik",
    "empty_message": "Nincs a szűrőknek megfelelő autó. Próbáld módosítani a feltételeket.",
    "results_count_label": "{count} autó található",
    "reset_filters_label": "Szűrők törlése"
  },
  "ai_recommender": {
    "eyebrow": "AI Tanácsadó",
    "title": "Nem tudod, melyiket válaszd?",
    "description": "Mondd el az igényeidet, és mesterséges intelligenciánk a készletünkből kiválasztja a számodra legjobb autókat.",
    "budget_label": "Költségvetés",
    "budget_placeholder": "Válassz...",
    "budgets": [
      {
        "value": "8000000",
        "label": "8 millió Ft-ig"
      },
      {
        "value": "12000000",
        "label": "12 millió Ft-ig"
      },
      {
        "value": "16000000",
        "label": "16 millió Ft-ig"
      },
      {
        "value": "20000000",
        "label": "20 millió Ft-ig"
      }
    ],
    "fuel_label": "Üzemanyag",
    "fuel_placeholder": "Mindegy",
    "body_label": "Karosszéria",
    "body_placeholder": "Mindegy",
    "usage_label": "Mire használnád?",
    "usage_placeholder": "Pl. családi autó hosszú utakra, alacsony fogyasztással...",
    "submit_label": "Ajánlás kérése",
    "submit_loading_label": "Elemzés folyamatban...",
    "error_message": "Az AI tanácsadó jelenleg nem elérhető. Kérlek, próbáld újra később.",
    "no_results_message": "Nem találtunk pontos egyezést, de nézd át a teljes készletünket!",
    "quick_view_label": "Megnézem"
  },
  "site_reviews": {
    "eyebrow": "Vélemények",
    "title": "Mit gondolnak az AutoPark szolgáltatásról?",
    "description": "Oszd meg a tapasztalataidat, hogy másoknak is segíts a döntésben.",
    "reward_hint": "💡 Bejelentkezett felhasználók vélemény írásáért kreditet kapnak: 5★ = 100, 4★ = 50, egyéb = 10 kredit.",
    "name_label": "Neved",
    "name_placeholder": "Pl. Kovács Béla",
    "rating_label": "Értékelés",
    "rating_empty": "Adj csillagot",
    "text_label": "Véleményed",
    "text_placeholder": "Írd le a tapasztalataidat az AutoPark szolgáltatásáról...",
    "submit_label": "Vélemény küldése",
    "submit_loading_label": "Küldés...",
    "empty_list_message": "Még nincs vélemény. Legyél az első!"
  },
  "contact": {
    "eyebrow": "Kapcsolat",
    "title": "Érdeklődj nálunk",
    "description": "Töltsd ki az űrlapot, és kollégáink hamarosan felveszik veled a kapcsolatot. Akár konkrét autóról van szó, akár csak tanácsra van szükséged.",
    "channels": [
      {
        "label": "Telefon",
        "value": "+36 30 123 4567"
      },
      {
        "label": "Email",
        "value": "info@autopark.hu"
      },
      {
        "label": "Cím",
        "value": "1011 Budapest, Autó utca 1."
      }
    ],
    "prefill_template": "Érdeklődöm a következő autó iránt: {make} {model} ({year}). Kérem, vegyék fel velem a kapcsolatot.",
    "form_name_label": "Név",
    "form_email_label": "Email",
    "form_phone_label": "Telefonszám",
    "form_message_label": "Üzenet",
    "submit_label": "Üzenet küldése",
    "success_title": "Üzenet elküldve!",
    "success_body": "Köszönjük az érdeklődést, hamarosan jelentkezünk.",
    "success_again_label": "Új üzenet küldése",
    "toast_success": "Köszönjük! Hamarosan felvesszük veled a kapcsolatot.",
    "toast_error": "Hiba történt a küldés során. Kérlek, próbáld újra."
  },
  "support_chatbot": {
    "welcome_message": "Szia! Az AutoPark ügyfélszolgálati asszisztense vagyok. Kérdezz bátran a kredit rendszerről, kuponokról, hirdetés feladásról vagy kiegészítőkről — bármikor itt vagyok, teljesen ingyen. 👋",
    "header_title": "AutoPark Segítség",
    "input_placeholder": "Írd be a kérdésed…",
    "suggestions": []
  },
  "auth_page": {
    "back_label": "Vissza a főoldalra",
    "login_title": "Belépés eladóként",
    "register_title": "Regisztráció eladóként",
    "subtitle": "Hirdesd meg autóidat az AutoPark felületén.",
    "welcome_banner_html": "Regisztrálj és <b>20 kredit ajándékot</b> kapsz — azonnal feladhatsz egy hirdetést.",
    "google_button_label": "Folytatás Google-lel",
    "apple_button_label": "Folytatás Apple-lel"
  },
  "favorites_page": {
    "title": "Kedvenceim",
    "subtitle": "Az elmentett autóid ezen a böngészőn.",
    "empty_title": "Még nincs elmentett kedvenced.",
    "empty_body": "Kattints a szív ikonra bármelyik autónál, és itt találod meg később.",
    "browse_label": "Készlet böngészése",
    "price_drop_one": "Egy kedvenc autód ára csökkent",
    "price_drop_many": "{count} kedvenc autód ára csökkent",
    "price_drop_suffix": " az elmentés óta – zölddel jelöltük őket."
  },
  "car_detail": {
    "not_found_title": "Az autó nem található",
    "not_found_body": "Lehet, hogy a hirdetést időközben eltávolították.",
    "not_found_cta": "Vissza a készlethez"
  }
} ;
